import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { s3 } from 'src/services/awsS3';
import { getEnvVars } from 'src/utils';
import { v4 as uuidv4 } from 'uuid';

function AwsUploder({ children, cb, resourceType, accept }) {
  const [fileData, setFileData] = useState({});
  const [cloudFrontUrl, setCloudFrontUrl] = useState('');

  useEffect(() => {
    if (fileData && fileData.name) {
      uploadToS3();
    }
    // eslint-disable-next-line
  }, [fileData]);

  useEffect(() => {
    if (cloudFrontUrl !== '') {
      cb(cloudFrontUrl);
    }
    // eslint-disable-next-line
  }, [cloudFrontUrl]);

  const generateS3Config = file => {
    switch (resourceType) {
      case 'testimonial-image':
        return {
          Bucket: getEnvVars().s3BucketTestimonial,
          Key: getEnvVars().s3PathTestimonialImage.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'instructor-image':
        return {
          Bucket: getEnvVars().s3BucketInstructor,
          Key: getEnvVars().s3PathInstructorImage.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'instructor-resume':
        return {
          Bucket: getEnvVars().s3BucketInstructor,
          Key: getEnvVars().s3PathInstructorResume.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'catalogue-syllabus':
        return {
          Bucket: getEnvVars().s3BucketSyllabus,
          Key: getEnvVars().s3PathSyllabus.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };
      case 'store-icon':
        return {
          Bucket: getEnvVars().s3BucketStoreIcon,
          Key: getEnvVars().s3PathStoreIcon.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };
      case 'store-image':
        return {
          Bucket: getEnvVars().s3BucketStoreIcon,
          Key: getEnvVars().s3PathStoreImage.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };
      case 'question-paper':
        return {
          Bucket: getEnvVars().s3BucketQuestionPaper,
          Key: getEnvVars().s3PathQuestionPaper.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'test-schedule':
        return {
          Bucket: getEnvVars().s3BucketTestSchedule,
          Key: getEnvVars().s3PathTestSchedule.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'catalogue-image':
        return {
          Bucket: getEnvVars().s3BucketCatalogueImage,
          Key: getEnvVars().s3PathCatalogueImage.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'live-classes':
        return {
          Bucket: getEnvVars().s3BucketLiveCLassResources,
          Key: getEnvVars().s3PathLiveClassThumbnails.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };
      case 'feature-icon':
        return {
          Bucket: getEnvVars().s3BucketFeatureIcon,
          Key: getEnvVars().s3PathFeatureIcon.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
          ContentType: 'image/svg+xml',
        };
      case 'preview-video-thumbnail':
        return {
          Bucket: getEnvVars().s3BucketPreviewVideoThumbnail,
          Key: getEnvVars().s3PathPreviewVideoThumbnail.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };

      case 'preview-video-thumbnail-static':
        return {
          Bucket: getEnvVars().s3BucketPreviewVideoThumbnail,
          Key: getEnvVars().s3PathPreviewVideoThumbnailForStatic.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };
      case 'exam-syllabus-pdf':
        return {
          Bucket: getEnvVars().s3BucketSyllabus,
          Key: getEnvVars().s3PathExamSyllabus.replace(
            '{uuid-filename}',
            `${uuidv4()}-${file.name.replaceAll(' ', '')}`
          ),
          Body: file,
        };
      default:
        break;
    }
  };

  const generateCloudFrontConfig = () => {
    switch (resourceType) {
      case 'testimonial-image':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlTestimonial,
          fileUrl: getEnvVars().TestimonialFileUrl,
        };

      case 'instructor-image':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlInstructor,
          fileUrl: getEnvVars().InstructorImageFileUrl,
        };

      case 'instructor-resume':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlInstructor,
          fileUrl: getEnvVars().InstructorResumeFileUrl,
        };

      case 'catalogue-syllabus':
        return {
          cloudFrontUrl: getEnvVars().cloudFrounUrlSyllabus,
          fileUrl: getEnvVars().syllabusFileUrl,
        };
      case 'store-icon':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlStoreIcon,
          fileUrl: getEnvVars().storeIconFileUrl,
        };
      case 'store-image':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlStoreIcon,
          fileUrl: getEnvVars().storeIconFileUrl,
        };
      case 'question-paper':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlQuestionPaper,
          fileUrl: getEnvVars().questionPaperFileUrl,
        };
      case 'test-schedule':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrl,
          fileUrl: getEnvVars().testScheduleFileUrl,
        };
      case 'catalogue-image':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrlCatalogueImage,
          fileUrl: getEnvVars().catalogueImageFileUrl,
        };

      case 'live-classes':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrl,
          fileUrl: getEnvVars().catalogueImageFileUrl,
        };
      case 'feature-icon':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrl,
          fileUrl: getEnvVars().featureIconFileUrl,
        };
      case 'preview-video-thumbnail':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrl,
          fileUrl: getEnvVars().previewVideoThumbnailFileUrl,
        };
      case 'preview-video-thumbnail-static':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrl,
          fileUrl: getEnvVars().previewVideoThumbnailFileUrl,
        };
      case 'exam-syllabus-pdf':
        return {
          cloudFrontUrl: getEnvVars().cloudFrontUrl,
          fileUrl: getEnvVars().syllabusFileUrl,
        };
      default:
        break;
    }
  };

  const uploadToS3 = async () => {
    const s3Config = await generateS3Config(fileData);
    const { fileUrl, cloudFrontUrl } = await generateCloudFrontConfig();
    s3.upload(s3Config, err => {
      if (err) {
        console.log(err);
      }
      setCloudFrontUrl(
        fileUrl.replace('{cloudFrontUrl}', cloudFrontUrl).replace('{file-path}', s3Config.Key)
      );
    });
  };

  const onDrop = async files => {
    setFileData(files[0]);
  };

  return (
    <Dropzone onDrop={file => onDrop(file)} name="tnc" multiple={false} minSize={0} accept={accept}>
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          {children}
        </div>
      )}
    </Dropzone>
  );
}

export { AwsUploder };
